<template>
  <ProductBanner />
  <ProductWorth step="advantage" title="核心优势" />
  <ProductContrast />
  <ProductWorth step="framework" title="三维技术架构" />
  <ProductWorth step="deploy" title="灵活部署模式" />
</template>

<script lang="ts" type="text/tsx">
import ProductBanner from "@template/page/productPrivateAidigitalHuman/productBanner.vue";
import ProductWorth from "@template/page/productPrivateAidigitalHuman/productWorth.vue";
import ProductContrast from "@template/page/productPrivateAidigitalHuman/productContrast.vue";

export default {
  name: "productPrivateAidigitalHuman",
  components: {
    ProductBanner,
    ProductWorth,
    ProductContrast,
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "@resource/css/_global.less";

@image: "@{src_image}page/product/";
</style>